<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Configuración del Rubro">
          <b-form>
            <app-rubro-trabajo
              v-if="id == 0"
              label="Rubro"
              :nombre="rubroTrabajoNombre"
              :valido="rubroTrabajoValido"
              :lista="rubrosList"
              :msjInvalido="rubroTrabajoInvalidoMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="rubroTrabajoActualizado">
            </app-rubro-trabajo>  

            <b-form-group
              label="Rubro"
              label-for="rubroNombre"
              :label-cols="labelCols"
              v-if="id != 0"
              horizontal>
              <b-form-input 
                id="rubroNombre"
                :value="rubroTrabajoNombre" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="premios"
                  v-model="premios"
                  :value= "Boolean(true)"
                  :unchecked-value= "Boolean(false)">
                  Fee Diferenciado
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="noAplicaFee"
                  v-model="noAplicaFee"
                  :value= "Boolean(true)"
                  :unchecked-value= "Boolean(false)">
                  No Aplica Fee
              </b-form-checkbox>
            </b-form-group>

          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="close">Cerrar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import RubroTrabajo from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

// import { required, numeric, decimal, maxLength, minValue, maxValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'rubroTrabajoCliente/getField',
  mutationType: 'rubroTrabajoCliente/updateField',
});

export default {
  name: 'ABM',
  props: {
    clienteId: {
      type: Number,
      default: 0
    },
    rubroTrabajoClienteId: {
      type: Number,
      default: 0
    },
  },
  components: {
    appRubroTrabajo: RubroTrabajo,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      rubroTrabajoValido: null,
      rubroTrabajoInvalidoMsj: '',

      rubros: [],
      rubrosList: [],

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'rubroTrabajo',
      'rubroTrabajoNombre',
      'premios',
      'noAplicaFee',
    ]),
  },  
  created() {
    let params = {
      clienteId: this.clienteId,
      rubroTrabajoClienteId: this.rubroTrabajoClienteId
    }

    this.$store.dispatch('rubroTrabajoCliente/inicializar', params)
      .then(() => this.getDatosAdicionales());
  }, 
  methods: {
    getDatosAdicionales() {
      if (this.id == 0) {
        this.$store.dispatch('rubrostrabajos/getRubrosList')
          .then(() => {
            this.rubros = this.$store.getters['rubrostrabajos/rubrosList'];
            this.rubrosList = this.$store.getters['rubrostrabajos/rubrosSelectList'];
          })
          .catch(() => reject('Se produjo un error al recuperar la información de rubros de trabajo.'))
      }
    },
    validate(event) {
    },

    // validate(event) {
    //   if (event) {
    //     if (event.target) {
    //       /* Antes de intentar registrar por primera vez, no validamos */
    //       if (!this.noValidar) {
    //         this.$v.$touch();
    //         this.displayErrores(event.target.id);
    //       }
    //     }
    //   } 
    // },
    // displayErrores(field) {
    //   var validarTodos = false;
    //   var campo = '';

    //   if (field) {
    //     campo = field;
    //   } else {
    //     validarTodos = true;
    //   }

    //   if (campo == 'titulo' || validarTodos) {
    //     if (this.$v.titulo.$error) {
    //       this.tituloValido = false;
    //       if (!this.$v.titulo.required) {
    //         this.tituloInvalidoMsj= 'Debe ingresar el título de la orden.';
    //       } else if (!this.$v.titulo.maxLength) {
    //         this.tituloInvalidoMsj = 'El título sólo puede contener hasta 30 caracteres';
    //       }
    //     } else {
    //       this.tituloValido = null;
    //       this.tituloInvalidoMsj = '';
    //     }
    //   }

    //   if (campo == 'descripcion' || validarTodos) {
    //     if (this.$v.descripcion.$error) {
    //       this.descripcionValida = false;
    //       if (!this.$v.descripcion.maxLength) {
    //         this.descripcionInvalidaMsj = 'La descripción sólo puede contener hasta 5000 caracteres';
    //       }
    //     } else {
    //       this.descripcionValida = null;
    //       this.descripcionInvalidaMsj = '';
    //     }
    //   }

    //   if (campo == 'cantidad' || validarTodos) {
    //     if (this.$v.cantidad.$error) {
    //       this.cantidadValida = false;
    //       if (!this.$v.cantidad.numeric) {
    //         this.cantidadInvalidaMsj = 'La cantidad debe ser un valor numérico positivo';
    //       } else {
    //         if (!this.$v.cantidad.minValue) {
    //           this.cantidadInvalidaMsj = 'La cantidad ingresada no es válida';
    //         }      
    //       }
    //     } else {
    //       this.cantidadValida = null;
    //       this.cantidadInvalidaMsj = '';
    //     }
    //   }

    //   if (this.costoUnitario) {
    //     if (campo == 'costoEstimado' || validarTodos) {
    //       if (this.$v.costoEstimado.$error) {
    //         this.costoEstimadoValido = false;
    //         if (!this.$v.costoEstimado.decimal || !this.$v.costoEstimado.minValue) {
    //           this.costoEstimadoInvalidoMsj = 'El costo ingresado no es válido';
    //         }
    //       } else {
    //         this.costoEstimadoValido = null;
    //         this.costoEstimadoInvalidoMsj = '';
    //       }
    //     }
    //   } else {
    //     if (campo == 'costoEstimadoTotal' || validarTodos) {
    //       if (this.$v.costoEstimadoTotal.$error) {
    //         this.costoEstimadoTotalValido = false;
    //         if (!this.$v.costoEstimadoTotal.decimal || !this.$v.costoEstimadoTotal.minValue) {
    //           this.costoEstimadoTotalInvalidoMsj = 'El costo total ingresado no es válido';
    //         }
    //       } else {
    //         this.costoEstimadoTotalValido = null;
    //         this.costoEstimadoTotalInvalidoMsj = '';
    //       }
    //     }
    //   }
    // },

    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      
      if (this.rubroEditable) {
        let rubroTrabajoError = true;
        if (this.rubroTrabajo) {
          if (this.rubroTrabajo.id) {
            if (this.rubroTrabajo.id != 0) {
                rubroTrabajoError = false;
            }
          }
        }
        if (rubroTrabajoError) {
          this.rubroTrabajoValido = false;
          this.rubroTrabajoInvalidoMsj = 'Debe seleccionar el rubro correspondiente';
          save = false;
        }
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.$store.dispatch('rubroTrabajoCliente/save')
            .then(() => this.showModalMsj('Los cambios se registraron con éxito', this.close, this.close, 'light'))
            .catch(error => this.showErrorMsj(error));
        }
      }
    },
    close() {
      this.$emit('close');
    },
    rubroTrabajoActualizado(rubroTrabajoNombre) {
      let rubroTrabajo;
      if (rubroTrabajoNombre) {
        rubroTrabajo = this.getSelected(this.rubros, rubroTrabajoNombre);
      }
      this.$store.dispatch('rubroTrabajoCliente/setRubroTrabajo', rubroTrabajo);

      this.rubroTrabajoValido = null;
      this.rubroTrabajoInvalidoMsj = '';
    },
  },
  watch: {
  },    
  validations: {
  },  
}
</script>

<style>
</style>
